(function () {
  const script = document.currentScript;
  const mapUrl = script && script.dataset.mapUrl;
  if (!mapUrl) return;

  const applyLogos = (root, logoMap) => {
    root.querySelectorAll('.card__collection[data-brand-handle]').forEach((card) => {
      if (card.dataset.brandLogoEnhanced === 'true') return;

      let logoUrl = logoMap[card.dataset.brandHandle];
      const media = card.querySelector('.card__media .media');
      if (!logoUrl || !media) return;
      card.dataset.brandLogoEnhanced = 'true';

      const externalLogo = !logoUrl.startsWith('asset:') && !logoUrl.startsWith('data:');
      if (logoUrl.startsWith('asset:')) {
        const assetUrl = new URL(logoUrl.slice(6), script.src);
        assetUrl.search = '';
        logoUrl = assetUrl.href;
      }

      const currentImage = media.querySelector('img');
      const logo = document.createElement('img');
      logo.alt = `${card.querySelector('.card__title')?.textContent.trim() || card.dataset.brandHandle} logo`;
      logo.className = 'brand-logo-image';
      logo.width = 600;
      logo.height = 240;
      logo.loading = externalLogo ? 'eager' : 'lazy';
      logo.decoding = 'async';
      const loadTimeout = externalLogo ? window.setTimeout(() => logo.remove(), 5000) : null;
      logo.addEventListener('load', () => {
        if (loadTimeout) window.clearTimeout(loadTimeout);
        if (currentImage && currentImage !== logo) currentImage.remove();
        card.classList.add('card__collection--brand-logo');
      }, { once: true });
      logo.addEventListener('error', () => {
        if (loadTimeout) window.clearTimeout(loadTimeout);
        delete card.dataset.brandLogoEnhanced;
        logo.remove();
      }, { once: true });
      logo.src = logoUrl;
      media.appendChild(logo);
    });
  };

  fetch(mapUrl, { credentials: 'same-origin' })
    .then((response) => {
      if (!response.ok) throw new Error(`Logo map HTTP ${response.status}`);
      return response.json();
    })
    .then((logoMap) => {
      applyLogos(document, logoMap);
      new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) applyLogos(node, logoMap);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    })
    .catch((error) => console.warn('Brand logos could not be enhanced:', error));
}());
